import React, { useEffect } from 'react';
import './campos-componente-sessao.component.scss';
import { Button, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import { ItensMenuModel } from '../../models/menu.model';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import SessaoModel from '../../models/sessao.model';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { CONSTANTS } from '../../constants/constants';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import { ComponentsModel } from '../../models/layout.model';
import IDsMenuSelectComponent from '../ids-menu-select/ids-menu-select.component';
import Editor from 'react-simple-wysiwyg';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type CamposComponenteSessaoProps = {
  setVal: (val: ComponentsModel) => void;
  removeItem: (id?: string) => void;
  componente?: ComponentsModel;
  menu: ItensMenuModel[];
}

function CamposComponenteSessaoComponent(props: CamposComponenteSessaoProps) {

  const [idInput, setIdInput] = React.useState(props.componente?.sessao ? props.componente.sessao.id : '');
  const [tituloInput, setTituloInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.titulo : '');
  const [alinhamentoTituloInput, setAlinhamentoTituloInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.alinhamento_titulo : '');
  const [descricaoInput, setDescricaoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.descricao : '');
  const [alinhamentoDescricaoInput, setAlinhamentoDescricaoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.alinhamento_descricao : '');
  const [imagemInput, setImagemInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.imagem : '');
  const [layoutInput, setLayoutInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.layout : '');

  const [isFullInput, setIsFullInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.full : false);
  const [bgInput, setBgInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.bg : '');
  const [corDoTituloInput, setCorDoTituloInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.cor_do_titulo : '');
  const [corDoTextoInput, setCorDoTextoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.cor_do_texto : '');
  const [textoBotaoInput, setTextoBotaoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.texto_botao : '');
  const [urlBotaoInput, setUrlBotaoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.url_botao : '');
  const [tipoBotaoInput, setTipoBotaoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.tipo_botao : '');
  const [corTextoBotaoInput, setCorTextoBotaoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.cor_texto_botao : '');
  const [corBgBotaoInput, setCorBgBotaoInput] = React.useState(props.componente?.sessao ? props.componente.sessao?.cor_bg_botao : '');

  const [valueTab, setValueTab] = React.useState(0);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      id: props.componente?.id,
      tipo: CONSTANTS.TIPO_COMPONENTE.SESSAO,
      sessao: {
        id: idInput,
        titulo: tituloInput,
        descricao: descricaoInput.replace(/"/g, '\\"'),
        alinhamento_titulo: alinhamentoTituloInput,
        alinhamento_descricao: alinhamentoDescricaoInput,
        imagem: imagemInput,
        layout: layoutInput,
        full: isFullInput,
        bg: bgInput,
        cor_do_titulo: corDoTituloInput,
        cor_do_texto: corDoTextoInput,
        texto_botao: textoBotaoInput,
        url_botao: urlBotaoInput,
        tipo_botao: tipoBotaoInput,
        cor_texto_botao: corTextoBotaoInput,
        cor_bg_botao: corBgBotaoInput
      }
    });
  };

  return (
    <section className="campos-componente-sessao">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTab}
            onChange={(event: React.SyntheticEvent, newValue: number) => setValueTab(newValue)}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
            <Tab label="Estilo" {...a11yProps(1)} />
            <Tab label="Ação" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <h2>Geral</h2>
          {
            (props.menu.length && props.componente) &&
            <div className="campo w100">
              <IDsMenuSelectComponent val={props.componente?.sessao?.id} menus={props.menu} setVal={(val) => setIdInput(val)} />
            </div>
          }

          {/* <div className="campo w50">
            <TextField value={idInput} onChange={(event) => setIdInput(event.target.value)} label="ID do menu" />
          </div> */}
          <div className="campo w100">
            <TextField value={tituloInput} onChange={(event) => setTituloInput(event.target.value)} label="Título" />
          </div>
          <div className="campo w50">
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
              <InputLabel id="demo-select-small-label">Alinhamento título</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={alinhamentoTituloInput}
                label="Alinhamento título"
                onChange={(event) => setAlinhamentoTituloInput(event.target.value)}
              >
                <MenuItem value="">
                  <em>Selelcione</em>
                </MenuItem>
                <MenuItem value={CONSTANTS.ALINHAMENTO.ESQUERDA}>{CONSTANTS.POSICAO_LOGO.ESQUERDA}</MenuItem>
                <MenuItem value={CONSTANTS.ALINHAMENTO.DIREITA}>{CONSTANTS.POSICAO_LOGO.DIREITA}</MenuItem>
                <MenuItem value={CONSTANTS.ALINHAMENTO.CENTRO}>{CONSTANTS.POSICAO_LOGO.CENTRO}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="campo w50">
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
              <InputLabel id="demo-select-small-label">Alinhamento descrição</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={alinhamentoDescricaoInput}
                label="Alinhamento descrição"
                onChange={(event) => setAlinhamentoDescricaoInput(event.target.value)}
              >
                <MenuItem value="">
                  <em>Selelcione</em>
                </MenuItem>
                <MenuItem value={CONSTANTS.ALINHAMENTO.ESQUERDA}>{CONSTANTS.POSICAO_LOGO.ESQUERDA}</MenuItem>
                <MenuItem value={CONSTANTS.ALINHAMENTO.DIREITA}>{CONSTANTS.POSICAO_LOGO.DIREITA}</MenuItem>
                <MenuItem value={CONSTANTS.ALINHAMENTO.CENTRO}>{CONSTANTS.POSICAO_LOGO.CENTRO}</MenuItem>
                <MenuItem value={CONSTANTS.ALINHAMENTO.JUSTIFICADO}>Justificado</MenuItem>
              </Select>
            </FormControl>
          </div>
          {
            layoutInput != CONSTANTS.LAYOUT_SESSAO.APENAS_TEXTO &&
            <div className="campo w50">
              <AttachmentModalComponent setVal={(attachFile) => setImagemInput(attachFile.src)} file={{ id: '', src: imagemInput }} legenda='Imagem' />
            </div>
          }
          <div className="campo w50">
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
              <InputLabel id="demo-select-small-label">Layout</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={layoutInput}
                label="Layout"
                onChange={(event) => setLayoutInput(event.target.value)}
              >
                <MenuItem value="">
                  <em>Selelcione</em>
                </MenuItem>
                <MenuItem value={CONSTANTS.LAYOUT_SESSAO.APENAS_TEXTO}>{CONSTANTS.LAYOUT_SESSAO.APENAS_TEXTO}</MenuItem>
                <MenuItem value={CONSTANTS.LAYOUT_SESSAO.IMG_BG}>{CONSTANTS.LAYOUT_SESSAO.IMG_BG}</MenuItem>
                <MenuItem value={CONSTANTS.LAYOUT_SESSAO.IMG_DIR}>{CONSTANTS.LAYOUT_SESSAO.IMG_DIR}</MenuItem>
                <MenuItem value={CONSTANTS.LAYOUT_SESSAO.IMG_ESQ}>{CONSTANTS.LAYOUT_SESSAO.IMG_ESQ}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="campo w100">
            {/* <TextField rows={3} multiline value={descricaoInput} onChange={(event) => setDescricaoInput(event.target.value)} label="Descrição" /> */}
            <Editor value={descricaoInput} onChange={(e) => setDescricaoInput(e.target.value)} />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <h2>Estilo sessão</h2>
          <div className="campo w100">
            <FormControlLabel
              control={
                <Checkbox defaultChecked={false} onChange={(event) => setIsFullInput(event.target.checked)} />
              }
              label="Full"
            />
          </div>
          <label className='w50'>
            <span>Cor do fundo:</span>
            <input type='color' value={bgInput} onChange={(val) => setBgInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do título:</span>
            <input type='color' value={corDoTituloInput} onChange={(val) => setCorDoTituloInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto:</span>
            <input type='color' value={corDoTextoInput} onChange={(val) => setCorDoTextoInput(val.currentTarget.value)} />
          </label>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <h2>Ação sessão</h2>
          <div className="campo w100">
            <TextField value={textoBotaoInput} onChange={(event) => setTextoBotaoInput(event.target.value)} label="Texto botão" />
          </div>
          {
            textoBotaoInput &&
            <>
              <div className="campo w50">
                <TextField value={urlBotaoInput} onChange={(event) => setUrlBotaoInput(event.target.value)} label="URL botão" />
              </div>
              <div className="campo w50">
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
                  <InputLabel id="demo-select-small-label">Tipo botão</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={tipoBotaoInput}
                    label="Tipo botão"
                    onChange={(event) => setTipoBotaoInput(event.target.value)}
                  >
                    <MenuItem value="">
                      <em>Selelcione</em>
                    </MenuItem>
                    <MenuItem value={CONSTANTS.TIPO_BOTAO.LINK_INTERNO}>{CONSTANTS.TIPO_BOTAO.LINK_INTERNO}</MenuItem>
                    <MenuItem value={CONSTANTS.TIPO_BOTAO.LINK_EXTERNO}>{CONSTANTS.TIPO_BOTAO.LINK_EXTERNO}</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </>
          }
          <label className='w50'>
            <span>Cor do texto do botão:</span>
            <input type='color' value={corTextoBotaoInput} onChange={(val) => setCorTextoBotaoInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do fundo do botão:</span>
            <input type='color' value={corBgBotaoInput} onChange={(val) => setCorBgBotaoInput(val.currentTarget.value)} />
          </label>
        </CustomTabPanel>
      </Box>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.componente?.id)}><DeleteIcon /> Remover sessão</Button>
      </div>
    </section>
  );
}

export default CamposComponenteSessaoComponent;
